import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { snakeCase } from 'lodash';

export interface IGenericCrudRequestConstructionParameters {
  joins?: string[];
  limit?: number;
  page?: number;
  filters?: Record<string, unknown>;
  search?: {
    searchText: string;
    searchedFields: string[];
  };
  sort?: Sort[];
}

@Injectable({
  providedIn: 'root',
})
export class HttpUtilitiesService {
  public insertGenericCrudRequestParameters(parameters: IGenericCrudRequestConstructionParameters): HttpParams {
    return HttpUtilitiesService.insertCrudRequestParameters(parameters);
  }

  private static insertCrudRequestParameters(parameters: IGenericCrudRequestConstructionParameters): HttpParams {
    let params: HttpParams = new HttpParams();

    if (parameters.page) {
      params = params.set('skip', String((parameters.page - 1) * (parameters.limit ?? 5)));
    }

    if (parameters.limit) {
      params = params.set('limit', String(parameters.limit));
    }

    for (const sort of parameters.sort ?? []) {
      params = params.append('order_by', `${sort.direction === 'desc' ? '-' : ''}${snakeCase(sort.active)}`);
    }

    if (parameters.joins?.length) {
      params = params.set('joins', parameters.joins.join(','));
    }

    if (parameters.search?.searchedFields?.length && parameters.search?.searchText) {
      for (const field of parameters.search.searchedFields) {
        params = params.append(`${field}`, parameters.search.searchText);
      }
    }

    if (parameters.filters) {
      for (const [key, value] of Object.entries(parameters.filters)) {
        if (value === undefined || value === null || (Array.isArray(value) && value.length === 0)) {
          continue;
        }

        if (Array.isArray(value)) {
          params = params.set(key, value.join(','));
        } else {
          params = params.set(key, String(value));
        }
      }
    }

    return params;
  }
}
